import { s } from './icon.style'
import React from 'react'
import type { IconProps } from '../iconProps'

export const DownloadIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 10H15V4H9V10H5L12 17L19 10ZM5 19V21H19V19H5Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  }
)
